import { Box } from "@mui/material"
import { LightTooltip } from "lib/@components/light-tool-tip"
import Iconify from "minimals-template/components/Iconify"
import { FieldInfo } from "./field-info"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { ExtendedSelectRight } from "slot-definitions"

ExtendedSelectRight("*").plug(<FieldSelectorTooltip />)

export function FieldSelectorTooltip() {
    const {
        item: { description, required, multiple, allowFixedValue = true },
        selectId,
    } = useBoundContext()
    return (
        <LightTooltip
            title={
                <FieldInfo
                    description={description}
                    required={required}
                    allowMultiple={multiple}
                    allowFixedValue={!required && allowFixedValue}
                />
            }
            arrow
        >
            <Box component="span" sx={{ lineHeight: 0 }} data-cy={`field-info-${selectId}`}>
                <Iconify
                    icon="ic:round-info"
                    sx={{
                        width: 24,
                        height: 24,
                        color: "primary.main",
                    }}
                />
            </Box>
        </LightTooltip>
    )
}
